// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/list_vision_invites.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionInviteView } from "./vision_membership_pb";
import { file_vision_membership_v1_vision_membership } from "./vision_membership_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/list_vision_invites.proto.
 */
export const file_vision_membership_v1_list_vision_invites: GenFile = /*@__PURE__*/
  fileDesc("Ci52aXNpb24vbWVtYmVyc2hpcC92MS9saXN0X3Zpc2lvbl9pbnZpdGVzLnByb3RvEhtwcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEihgEKGExpc3RWaXNpb25JbnZpdGVzUmVxdWVzdBJMCgZwYXJhbXMYASABKAsyPC5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuTGlzdFZpc2lvbkludml0ZXNSZXF1ZXN0LlBhcmFtcxocCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCSK0AQoZTGlzdFZpc2lvbkludml0ZXNSZXNwb25zZRJNCgZyZXN1bHQYASABKAsyPS5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuTGlzdFZpc2lvbkludml0ZXNSZXNwb25zZS5SZXN1bHQaSAoGUmVzdWx0Ej4KB2ludml0ZXMYASADKAsyLS5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuVmlzaW9uSW52aXRlVmlld2IGcHJvdG8z", [file_vision_membership_v1_vision_membership]);

/**
 * @generated from message protos.vision.membership.v1.ListVisionInvitesRequest
 */
export type ListVisionInvitesRequest = Message<"protos.vision.membership.v1.ListVisionInvitesRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.ListVisionInvitesRequest.Params params = 1;
   */
  params?: ListVisionInvitesRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.ListVisionInvitesRequest.
 * Use `create(ListVisionInvitesRequestSchema)` to create a new message.
 */
export const ListVisionInvitesRequestSchema: GenMessage<ListVisionInvitesRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_list_vision_invites, 0);

/**
 * @generated from message protos.vision.membership.v1.ListVisionInvitesRequest.Params
 */
export type ListVisionInvitesRequest_Params = Message<"protos.vision.membership.v1.ListVisionInvitesRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.membership.v1.ListVisionInvitesRequest.Params.
 * Use `create(ListVisionInvitesRequest_ParamsSchema)` to create a new message.
 */
export const ListVisionInvitesRequest_ParamsSchema: GenMessage<ListVisionInvitesRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_list_vision_invites, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.ListVisionInvitesResponse
 */
export type ListVisionInvitesResponse = Message<"protos.vision.membership.v1.ListVisionInvitesResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.ListVisionInvitesResponse.Result result = 1;
   */
  result?: ListVisionInvitesResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.ListVisionInvitesResponse.
 * Use `create(ListVisionInvitesResponseSchema)` to create a new message.
 */
export const ListVisionInvitesResponseSchema: GenMessage<ListVisionInvitesResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_list_vision_invites, 1);

/**
 * @generated from message protos.vision.membership.v1.ListVisionInvitesResponse.Result
 */
export type ListVisionInvitesResponse_Result = Message<"protos.vision.membership.v1.ListVisionInvitesResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.membership.v1.VisionInviteView invites = 1;
   */
  invites: VisionInviteView[];
};

/**
 * Describes the message protos.vision.membership.v1.ListVisionInvitesResponse.Result.
 * Use `create(ListVisionInvitesResponse_ResultSchema)` to create a new message.
 */
export const ListVisionInvitesResponse_ResultSchema: GenMessage<ListVisionInvitesResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_list_vision_invites, 1, 0);

